import axios from "axios";
import {API_URL} from "@/service/config";
import authHeader from "@/service/auth-header";

export const AuthApi = {
    async register(
        email,
        password,
        fingerprint,
        username,
        phoneNumber,
        register_type
    ) {
        let response = {}
        try {
            response = await axios.post(
                API_URL + "/auth/register",
                {
                    email: email,
                    password: password,
                    fingerprint: fingerprint,
                    full_name: username,
                    phone_number: {
                        country_code: "7",
                        number: phoneNumber
                    },
                    register_type:register_type
                },
                {
                    withCredentials: true
                }
            )
        }
        catch (e) {
            if (!e.response){
                return
            }
            else if (e.response.status === 400) {
                return {
                    status: "error",
                    message: "Такой email уже используется"
                }
            }
            else if (e.response.status === 403 || e.response.status === 500) {
                return {
                    status: "error",
                    message: "Что-то пошло не так. Напишите на почту support@tergum.ru"
                }
            } else {
                return {
                    status: "error",
                    message: "Что-то пошло не так. Напишите на почту support@tergum.ru"
                }
            }
        }

        localStorage.setItem("accessToken", response.data.access_token)
        localStorage.setItem("tokenType", response.data.token_type)
        localStorage.setItem("expiresAt", response.data.expires_at)

        return {
            status: "success",
        }
    },
    async login(
        email,
        password,
        fingerprint,
        register_type
    ) {
        let response = {}
        try {
            response = await axios.post(
                API_URL + "/auth/login",
                {
                    email: email,
                    password: password,
                    fingerprint: fingerprint,
                    register_type: register_type
                },
                {
                    withCredentials: true
                }
            )
        }
        catch (e) {
            if (!e.response){
                return
            }
            if (e.response.status === 401) {
                return {
                    status: "error",
                    message: "Неправильный логин или пароль",
                    code: 400
                }
            }
            else if (e.response.status === 403) {
                return {
                    status: "error",
                    message: "Что-то пошло не так. Напишите на почту support@tergum.ru",
                    code: 403
                }
            } else {
                return {
                    status: "error",
                    message: "Что-то пошло не так. Напишите на почту support@tergum.ru",
                }
            }
        }

        let access_token = response.data.access_token

        localStorage.setItem("accessToken", access_token)
        localStorage.setItem("tokenType", response.data.token_type)
        localStorage.setItem("expiresAt", response.data.expires_at)

        return {
            status: "success",
        }
    },
    async logout() {
        try {
            await axios.post(
                API_URL + "/auth/logout",
                {
                },
                {
                    withCredentials: true
                }
            )
        } catch (error) {console.log(error)}
        finally {
            localStorage.removeItem("accessToken")
            localStorage.removeItem("tokenType")
            localStorage.removeItem("expiresAt")
        }


    },
    async refreshToken(
        fingerprint
    ) {
        let response = {}
        try {
            response = await axios.post(
                API_URL + "/auth/tokens/refresh",
                {
                    fingerprint: fingerprint,
                },
                {
                    withCredentials: true
                }
            )
        }
        catch (e) {
            if (e.response && e.response.status === 401) {
                return {
                    code: 401,
                    status: "error"
                }
            }
            if (e.response && e.response.status === 403) {
                return {
                    code: 403,
                    status: "error"
                }
            }
            return {
                status: "error",
            }
        }

        localStorage.setItem("accessToken", response.data.access_token)
        localStorage.setItem("tokenType", response.data.token_type)
        localStorage.setItem("expiresAt", response.data.expires_at)

        return {
            status: "success",
        }
    },
    async isUserConfirmed() {
        let response = await axios.get(
            API_URL + "/auth/user/is_confirmed",
            {
                headers: {
                    "Authorization": authHeader()
                }
            }
        )
        return response.data
    },
    async checkIfEmailInUse(email) {
        let response = {}
        try {
            response = await axios.post(
                API_URL + "/auth/email/check",
                {
                    email: email
                },
            )
        }
        catch (e) {
            return {
                status: "error",
                message: "Что-то пошло не так. Напишите на почту support@tergum.ru"
            }
        }
        return {
            status: "success",
            value: response.data
        }
    },
    async changePassword(old_password, new_password){
        try {
            await axios.post(
                API_URL + "/auth/password",
                {
                    old_password: old_password,
                    new_password: new_password
                },
                {
                    headers: {
                        "Authorization": authHeader()
                    },
                    withCredentials: true
                }
            )
        }
        catch (e) {
            if (e.response?.status === 400) {
                return {
                    status: "error",
                    message: e.response.data?.detail || "Некорректные данные"
                }
            }

            return {
                status: "error",
                message: "Что-то пошло не так. Напишите на почту support@tergum.ru"
            }
        }
        return {
            status: "success",
        }

    }
}